function getPushedAdvertCards(): Element[] {
    return Array.from(document.querySelectorAll(".ladies-card.pushed"))
}

function getAdvertIdFromCard(card: Element): number | null {
    const advertId = Number.parseInt(card.id.replace("card-gallery-", ""), 10)
    return Number.isNaN(advertId) ? null : advertId
}

function isAlreadyTracked(advertId: number, place: number): boolean {
    return (
        document.body.querySelector(`.tracker.t-${siteConfig.trackingTagsMap.pushedadvert}-a${advertId}-p${place}`) !==
        null
    )
}

function trackPushedAdverts(): void {
    for (const [index, card] of getPushedAdvertCards().entries()) {
        const place = index + 1
        const advertId = getAdvertIdFromCard(card)

        if (advertId === null) continue
        if (isAlreadyTracked(advertId, place)) continue

        window.Tracking.trackPushedAdvertEinblendung(advertId, place)
    }
}

trackPushedAdverts()

window.addEventListener("azm.view-type.change", trackPushedAdverts)
window.addEventListener("azm.pagination.change", trackPushedAdverts)
window.addEventListener("azm.next-distance.after-load", trackPushedAdverts)
